import { TypedOmit } from '@client/new/helpers/types';
import { CreateChallengeInput, UpdateChallengeInput } from 'generated/graphql';

type ChallengePartBase = {
  data: [Date, Date];
  photos: boolean;
};

export type ChallengeStart = ChallengePartBase & {
  instagram: boolean;
  goal: boolean;
};

export type ChallengeEnd = ChallengePartBase & {
  testimonial: boolean;
};
type ChallengeMode = 'ready' | 'registration' | 'completion' | 'finished';
export type LiteChallenge = {
  challengeId: string;
  submissionsURL: string;
  createdAt: number;
  mode: ChallengeMode;
  name: string;
  registration: ChallengeStart;
  completion: ChallengeEnd;
  photoInstructions: string;
  templates: Array<string>;
  submissionsCount: number;
  hidePhotos: boolean;
};

export type LiteChallengeWithoutMeta = TypedOmit<
  LiteChallenge,
  'mode' | 'submissionsCount' | 'submissionsURL'
>;

export type CreateChallengePayload = CreateChallengeInput;
export type UpdateChallengePayload = UpdateChallengeInput;

export type MediaType = 'video' | 'photo';
export type SubmissionMedia = {
  type: MediaType;
  url: string;
  width: number;
  height: number;
  thumbnailURL: string;
};
export const userStatuses = ['Active', 'Canceled', 'Inactive'] as const;
export type UserStatus = (typeof userStatuses)[number];
export type Submission = {
  submissionId: string;
  username: string;
  email: string;
  isFav: boolean;

  beforeMedia: Array<SubmissionMedia>;
  afterMedia: Array<SubmissionMedia>;
  // transformationMedia: Array<SubmissionMedia>;

  testimonial: string;
  instagram: string;
  goal: string;

  beforeDate?: Date;
  afterDate?: Date;

  repostable: boolean;

  userStatus: UserStatus | null;
  statusDate: string; // to show: Renews on Jan 20, 2025
  workoutsTotal: number;
  workoutsCompleted: number;
};

export type Challenge = LiteChallenge & {
  submissions: Array<Submission>;
};
